import { SVGProps } from 'react';

const VisaIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="124"
      height="24"
      viewBox="0 0 124 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M71.7416 2C67.359 2 63.4423 4.27193 63.4423 8.46853C63.4423 13.2818 70.3885 13.6142 70.3885 16.0326C70.3885 17.0508 69.2219 17.9622 67.2287 17.9622C64.4007 17.9622 62.2869 16.6887 62.2869 16.6887L61.3823 20.9243C61.3823 20.9243 63.8174 22 67.0501 22C71.8417 22 75.6126 19.6169 75.6126 15.348C75.6126 10.2616 68.6374 9.93908 68.6374 7.69495C68.6374 6.89728 69.5951 6.0236 71.5822 6.0236C73.8245 6.0236 75.6534 6.9498 75.6534 6.9498L76.5388 2.85946C76.5388 2.85946 74.548 2 71.741 2H71.7416ZM31.6434 2.30894L31.5371 2.92619C31.5371 2.92619 33.3808 3.26355 35.0417 3.93704C37.1802 4.70876 37.3322 5.15858 37.6924 6.55374L41.6165 21.6812H46.8771L54.9811 2.30894H49.7329L44.5255 15.4802L42.4006 4.31518C42.206 3.03741 41.2186 2.30832 40.0106 2.30832H31.644L31.6434 2.30894ZM57.0918 2.30894L52.9749 21.6812H57.9797L62.0818 2.30894H57.0918ZM85.0049 2.30894C83.7982 2.30894 83.1587 2.95523 82.6898 4.08409L75.3574 21.6812H80.6057L81.6208 18.7481H88.0146L88.6319 21.6812H93.2628L89.2232 2.30894H85.0049ZM85.6877 7.54296L87.2435 14.8123H83.0759L85.6883 7.54296H85.6877Z"
        fill="#1434CB"
      />
    </svg>
  );
};

export default VisaIcon;
